import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NgForm, FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DownloadfileComponent } from '../downloadfile/downloadfile.component';
//import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { INTERACTEVENTS, IMPRESSIONEVENTS } from 'app/shared/constants';
import { Appconstants } from '../../../shared/app-constants';
import { InvestorService } from '../investor.service'
import {environment} from '../../../../environments/environment.prod';
import { MatRadioModule } from '@angular/material/radio';
@Component({
    selector: 'app-taxform-non-residential',
    templateUrl: './taxform-non-residential.component.html',
    styleUrls: ['./taxform-non-residential.component.css'],
    standalone: true,
    imports: [FormsModule, CommonModule, ReactiveFormsModule , MatRadioModule, DownloadfileComponent]
})
export class TaxformNonResidentialComponent implements OnInit {
  // add private telemetryService:TelemetryService
  //constructor(private investorService: InvestorService,private telemetryService:TelemetryService) { }
  constructor(private investorService: InvestorService) { }
  @Input() formName: string = '';
  @Output() onSubmit = new EventEmitter();
  @Output() pageName = new EventEmitter();
  @Output() scrollOnLoad = new EventEmitter();

  @Input() currentType: string = ''; // Add this new input property
  @Input() cycleId: string = ''; // Add this new input property


  strVerifyResponse: Record<string, any> = {};
  strErrorMessage: string = "";
  strSuccessMessage: string = "";
  strFileSizeError: string = "";
  strFileNameError: string = "";
  document: { documentType: string, documentContent: string, documentName: string, cycleId?: string } = {
    documentType: "", documentContent: "", documentName: ""
  };
  fileByte: string = '';
  invDocTypeFlag: boolean = false;
  disableSubmit: boolean = true;
  fileValidFlag: boolean | null = null;
  pageLoad: boolean = false;
  decCheck:boolean=false;
  downloadTempLink:string='';
  reloadComponent: boolean = true;
  @Input() cycleFlag:boolean=false;
  @Input() selYear:string='';
  @Input() cycleName:string='';
  @Input() windowFlag:boolean=false;
  enableSubmitFlag:boolean=false;
  blnShowLoad: boolean = true;

  ngOnInit() {
    if(this.windowFlag==false && this.enableSubmitFlag==true){
      this.windowFlag=true;
    }
    console.log("formName", this.formName);
    // if (this.formName != 'otherform') {
    //   this.document.documentType = this.formName;
    // }
    // this.document.documentType = this.formName;
    // // add telemetry on page load

    if(environment.telemetryFlg){
    let impressionEventData = {
      type: IMPRESSIONEVENTS.FORM,
      pageid: Appconstants.taxFormsNonResidentialPageId,
      uri: window.location.href
    };
   // this.telemetryService.impression(impressionEventData);
  }
  
  
  }


  ngOnChanges(changes: SimpleChanges) {

    // Reset file upload validation messages
    this.strErrorMessage = "";
    this.strFileSizeError = "";
    this.strFileNameError = "";
    this.fileValidFlag = null;

    if(this.windowFlag==false && this.enableSubmitFlag==true){
      this.windowFlag=true;
    }
    for (let property in changes) {
      if (property === 'formName') {
        console.log('Previous:', changes[property].previousValue);
        console.log('Current:', changes[property].currentValue);
      }
    }  
    
    // Add null check before accessing currentValue
    if (changes['formName'] && changes['formName'].currentValue) {
      this.formName = changes['formName'].currentValue;
    }

    if (changes['formName'] && changes['formName'].currentValue) {
     // this.formName = changes['formName'].currentValue;
     // this.document.documentType = this.formName;
      
      // Add null check for cycleId
      if (changes['cycleId'] && changes['cycleId'].currentValue) {
        this.cycleId = changes['cycleId'].currentValue;
      }
    }
    
    // Add null check before accessing currentValue
    if (changes['formName'] && changes['formName'].currentValue && 
        changes['formName'].currentValue!='otherform' && 
        changes['formName'].currentValue!='TRC' && 
        changes['formName'].currentValue!='LTDC') {
      this.generateDownloadLink();
    }
    
    if (this.formName != 'otherform') {
          this.document.documentType = this.formName;
    }
    else{
      this.document.documentType = "others";
    }
    this.scrollOnLoad.emit(true);
    this.consentFormChange();
    this.document.documentName = '';
    this.document.documentContent = '';
    this.reloadComponent= true;
    
    // Add null check before accessing previousValue
    if(changes['formName'] && changes['formName'].previousValue != null){
      (<HTMLInputElement>document.getElementById('NRDocupload'+ changes['formName'].previousValue)).value = "";
    }
    
    console.log("onChange",this.formName,this.document.documentType);
    this.investorService.getAllDocByType(this.document.documentType,this.selYear,this.cycleName).subscribe(data=>{
      if(data['enable_submit'].toLowerCase()=="y"){
        this.enableSubmitFlag=true;
      }
      //this.blnShowLoad = false;
    },
    err=>{
      console.log("err",err);
      //this.blnShowLoad = false;
    })
    console.log("boolean show load", this.blnShowLoad);
    console.log("window flag",this.windowFlag);
    console.log("enable submit flag",this.enableSubmitFlag);
  }
 

  generateDownloadLink(){
    this.downloadTempLink = "assets/Templates/";
    console.log(this.formName);
    let docName;
    if(this.formName=="No PE declaration"){
      this.formName="No PE declaration";
    docName= "No PE declaration";
    }
    else{
      let names = this.formName.split(' ');
    docName = names.join('-');
    docName= docName.replace('.','');
    }
    this.downloadTempLink = this.downloadTempLink + docName + '.pdf'
    console.log("download",this.downloadTempLink);
    
    // return this.downloadTempLink; 
  }

  consentFormChange(){
    this.decCheck=false;
    this.disableSubmit = true;
    this.strErrorMessage="";
   
   
  }

  convertFileToByte(file: File) {
    var fileReader: FileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onloadend = (e) => {
      this.fileByte = fileReader.result as string;
      this.fileByte = this.fileByte.split(',')[1];
      this.document.documentContent = this.fileByte;
      this.document.documentName = file.name;
      console.log("totalfiles", this.fileByte);
    };
  }

  validateType(type: string, name: string): boolean {
    // let accept = ['application/msword', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint',
    //   'text/plain',' application/pdf', 'image/*'];
    // .xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf
  let re =/(\.pdf)$/
    if( type.match('image/*')){

      return true;
    }
    else if(re.exec(name)){
      return true;
    }
    else {
      return false;
    }

  }

  attachFile(target: any) {
    console.log("target", target['files']);
    if (target['files'].length > 0) {
       const fileName = target['files'][0]['name'];
      if (fileName.length > 100) {
        this.strFileNameError = 'File name must not exceed 100 characters.';
        target.value = '';
        this.document['documentContent'] = '';
        this.document['documentName'] = '';
        this.fileValidFlag = false;
        this.disableSubmit = true;
        return;
      }

      this.strFileNameError = '';
      // Check file size (5MB = 5 * 1024 * 1024 bytes)
      const maxSize = 5 * 1024 * 1024;
      if (target['files'][0]['size'] > maxSize) {
        this.strFileSizeError = 'You are not allowed to upload files more than 5MB. Please reduce file size and try to upload again.';
        target.value = '';
        this.document['documentContent'] = '';
        this.document['documentName'] = '';
        this.fileValidFlag = false;
        this.disableSubmit = true;
        return;
      }
      
      // Clear file size error if valid
      this.strFileSizeError = '';
      
      if (this.validateType(target['files'][0]['type'], fileName)) {
        this.convertFileToByte(target['files'][0]);
        this.fileValidFlag = true;
      }
      else {
        console.log("invalid file");
        this.fileValidFlag = false;
        this.document['documentContent'] = '';
        this.document['documentName'] = '';
      }
      if (this.decCheck) {
        this.disableSubmit = false;
      }
    }
    else {
      //console.log("invalid file");
      this.fileValidFlag = false;
      this.fileByte = '';
      if (this.decCheck) {
        this.disableSubmit = true;
      }
      else {
        this.disableSubmit = true;
      }
      this.document['documentContent'] = '';
      this.document['documentName'] = '';
    }
  }

  checkConsent(event: any){
    if(event.target.checked){
      this.decCheck=true;
       this.disableSubmit = false;
    }
    else{
      this.decCheck=false;
      this.disableSubmit = true;
      
    }
  }

  fnTakeAction(){
    console.log("in submit");
    console.log(this.document);
    if(this.document.documentType == ''|| this.document.documentType==null){
      this.invDocTypeFlag =true;
      return;
    }
    if(this.document.documentName == '' || this.document.documentName == null){
      this.strErrorMessage = "Please attach the document";
      return;
    }
    this.pageLoad = true;
    this.document['cycleId'] = this.cycleId;
    this.investorService.postFormDocument(this.document).subscribe(data => {
      this.strVerifyResponse= data as Record<string, any>;
      console.log("output",  this.strVerifyResponse);
      if (this.strVerifyResponse['code'] == "1") {
          this.reloadComponent = false;
          if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: "Docupload"+" " +Appconstants.submit + " " + Appconstants.success,
            pageid: Appconstants.taxFormsNonResidentialPageId
          }
        //  this.telemetryService.interact(telemetryEventData);
        }
      // this.strSuccessMessage = "Thanks for providing the details the same is under processing.";
        this.strErrorMessage = '';
        this.pageLoad = false;
        this.pageName.emit('NONRESIDENT');
        setTimeout(() => {
          //this.strSuccessMessage="";
          this.reloadComponent = true;
        }, 100);

        this.resetAfterSubmit();
        this.reset();
      }
      else{
        this.strErrorMessage=this.strVerifyResponse['message'];
        this.pageLoad = false;
            if(environment.telemetryFlg){
              let telemetryEventData = {
                type: INTERACTEVENTS.CLICK,
                id: Appconstants.submit + " " + Appconstants.error +" "+ this.strErrorMessage ,
                pageid: Appconstants.taxFormsNonResidentialPageId
              }
            // this.telemetryService.interact(telemetryEventData);
          }
          setTimeout(() => {
            this.strErrorMessage="";
          }, 3000);
       
      }
    },err=>{
      console.log(err);
      this.strErrorMessage="Some Error Occured, Please try later.";
      this.pageLoad = false;
          if(environment.telemetryFlg){
          let telemetryEventData = {
            type: INTERACTEVENTS.CLICK,
            id: Appconstants.submit + " " + Appconstants.failure +" "+ err ,
            pageid: Appconstants.taxFormsNonResidentialPageId
          }
      //    this.telemetryService.interact(telemetryEventData);
      }
      setTimeout(() => {
        this.strErrorMessage="";
      }, 3000);
    
    });
  }

  reset() {
    this.document['documentContent'] = '';
    this.document['documentName'] = '';
    (<HTMLInputElement>document.getElementById('NRDocupload'+this.formName)).value = "";
    console.log(this.document);
    
  }

  checkDisableSubmit(){
    if(this.disableSubmit==false && this.fileValidFlag == true){
      return false;
    }
    else{
      return true;
    }
  }

  DownloadTemplate(){

    
  }

  resetAfterSubmit(){
    this.decCheck = false;
    this.fileValidFlag = null;
    this.disableSubmit = true;
  }


}